import styles from "./Testimonial.module.css";
import React from "react";
import Modal from "../Modal/Modal";
import Loader from "../Loader/index";

const AboutMe = React.lazy(() => import("../AboutMe/AboutMe"));
/* 
const img = require.context('../../assets', true); */
const Slide = ({ valueIndex, index, dataLength, data }) => {
  const [modal, setModal] = React.useState(false);
  const { work, testimony, date, profileImg } = data;

  // eslint-disable-next-line import/no-dynamic-require
  const img = require(`../../assets/testimonial/${profileImg}`);
  let position = "nextSlide";
  if (valueIndex === index) {
    position = "activeSlide";
  }

  if (
    valueIndex === index - 1 ||
    (index === 0 && valueIndex === dataLength - 1)
  ) {
    position = "lastSlide";
  }
  return (
    <>
      <React.Suspense fallback={<Loader />}>
        <Modal openModal={modal} fnCloseModal={() => setModal(false)}>
          <AboutMe />
        </Modal>
      </React.Suspense>
      <article className={`${styles.slide} ${styles[position]}`}>
        <div className={styles.left}>
          <div className={styles.slideImg}>
            <img width="300px" height="300px" src={img} alt="company" />
          </div>
          <div className={styles.details}>
            <button
              className={styles.homeBtn}
              type="button"
              onClick={() => setModal(true)}
            >
              🤖 Jonathan Mendoza 👾
            </button>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.quote}>
            <i className="fa fa-linode" />
          </div>
          <div className={styles.content}>
            <h3>{work}</h3>
            <h4>{date}</h4>
            <p>{testimony}</p>
          </div>
        </div>
      </article>
    </>
  );
};

export default Slide;
